import { TYPE_BACS_CREDIT, TYPE_BACS_DEBIT, TYPE_FASTER_PAYMENTS, TYPE_CHAPS } from '../../config';
import { getPayments, getFromAccount } from '../bacsCredit/selectors';
import { getTemplateName, getCurrentTemplateId, getCurrentTemplateVersion } from './selectors';
import { getPaymentsList } from '../../states/payments/getPaymentsList';
import { isPayee } from '../payees/selectors';
import { getToAccount, getPayments as getBacsDebitPayments } from '../bacsDebit/selectors';
import { getChapsPaymentsList } from '../chaps/selectors';

const getAmount = (payment) => ({
	amount: {
		value: parseFloat((payment.amount || '').replace(/,/g, '')) || 0.0,
		currency: 'GBP',
	},
});

export const getBacsCreditTemplateFromPayments = (state) => {
	const name = getTemplateName(state);
	const id = getCurrentTemplateId(state);
	const payments = getPayments(state);
	const fromAccountId = getFromAccount(state);
	const debit = { account: fromAccountId };
	const version = getCurrentTemplateVersion(state);

	const entries = payments.map((payment) => ({
		debit,
		credit: { beneficiary: payment.toAccount },
		reference: payment.reference,
		...getAmount(payment),
		...(id && { id: payment.id }),
		hmrc_reference: payment.hmrcReference,
	}));

	const template = {
		template: { name, ...(id && { id }), ...(version && { version }), type: TYPE_BACS_CREDIT, entries },
	};
	return template;
};

export const getBacsDebitTemplateFromPayments = (state) => {
	const name = getTemplateName(state);
	const id = getCurrentTemplateId(state);
	const toAccountId = getToAccount(state);
	const credit = { account: toAccountId };
	const payments = getBacsDebitPayments(state);
	const version = getCurrentTemplateVersion(state);

	const entries = payments.map((payment) => ({
		credit,
		debit: { beneficiary: payment.fromAccount },
		reference: payment.reference,
		...getAmount(payment),
		...(id && { id: payment.id }),
		transaction_code: payment.transactionCode,
	}));

	const template = {
		template: { name, ...(id && { id }), ...(version && { version }), type: TYPE_BACS_DEBIT, entries },
	};
	return template;
};

export const getFasterPaymentTemplateFromPayments = (state) => {
	const name = getTemplateName(state);
	const payments = getPaymentsList(state);
	const id = getCurrentTemplateId(state);
	const version = getCurrentTemplateVersion(state);

	const mapPaymentToEntry = (payment) => ({
		debit: { account: payment.fromAccount },
		credit: isPayee(state, payment.toAccount) ? { beneficiary: payment.toAccount } : { account: payment.toAccount },
		reference: payment.reference,
		...getAmount(payment),
		...(id && { id: payment.id }),
	});

	const entries = payments ? payments.map(mapPaymentToEntry) : [];

	const template = {
		template: { name, ...(id && { id }), ...(version && { version }), type: TYPE_FASTER_PAYMENTS, entries },
	};
	return template;
};

export const getChapsTemplateFromPayments = (state) => {
	const name = getTemplateName(state);
	const payments = getChapsPaymentsList(state);
	const id = getCurrentTemplateId(state);
	const version = getCurrentTemplateVersion(state);

	const mapPaymentToEntry = (payment) => ({
		debit: { account: payment.fromAccount },
		credit: isPayee(state, payment.toAccount) ? { beneficiary: payment.toAccount } : { account: payment.toAccount },
		reference: payment.chapsReference || payment.reference,
		...getAmount(payment),
		...(id && { id: payment.id }),
	});

	const entries = payments ? payments.map(mapPaymentToEntry) : [];

	const template = {
		template: { name, ...(id && { id }), ...(version && { version }), type: TYPE_CHAPS, entries },
	};
	return template;
};

export const getTemplateFromPayments = (state, type) => {
	switch (type) {
		case TYPE_BACS_CREDIT:
			return getBacsCreditTemplateFromPayments(state);
		case TYPE_BACS_DEBIT:
			return getBacsDebitTemplateFromPayments(state);
		case TYPE_FASTER_PAYMENTS:
			return getFasterPaymentTemplateFromPayments(state);
		case TYPE_CHAPS:
			return getChapsTemplateFromPayments(state);

		default:
			return {};
	}
};
